import charityVettingApiSlice from 'api/charity-vetting/charityVettingApiSlice';
import CharityVettingRoutesPL from 'features/charity-vetting/country-specific-flows/pl-flow/routes/CharityVettingRoutesPL';
import { CountryCodeEnum } from 'features/charity-vetting/types/charityVettingTypes';
import { useLocation } from 'react-router';

import CharityVettingRoutesES from '../../country-specific-flows/es-flow/routes/CharityVettingRoutesES';
import CharityVettingRoutesFR from '../../country-specific-flows/fr-flow/routes/CharityVettingRoutesFR';
import CharityVettingRoutesPT from '../../country-specific-flows/pt-flow/routes/CharityVettingRoutesPT';
import CharityVettingRoutesUK from '../../country-specific-flows/uk-flow/routes/CharityVettingRoutesUK';
import { OnboardingLayout } from '../../onboarding-layout/OnboardingLayout';
import { getCountryCodeFromStorage } from '../../utils/storageHandlers';

/**
 * Selects the country-specific set of vetting routes. Validation schemas no
 * longer live here — each page owns its own Zod schema via
 * CharityVettingFormProvider.
 */
const CharityVettingCountryManagerContainer = () => {
  const { search } = useLocation();
  const { data: vetting } = charityVettingApiSlice.endpoints.getCharityVetting.useQuery();

  const urlParams = new URLSearchParams(search);
  const country =
    urlParams.get('country') ?? getCountryCodeFromStorage() ?? vetting?.countryIsoCode;

  const vettingCountryHandler = () => {
    switch (country) {
      case CountryCodeEnum.PT:
        return <CharityVettingRoutesPT />;
      case CountryCodeEnum.ES:
        return <CharityVettingRoutesES />;
      case CountryCodeEnum.PL:
        return <CharityVettingRoutesPL />;
      case CountryCodeEnum.FR:
        return <CharityVettingRoutesFR />;
      default:
        return <CharityVettingRoutesUK />;
    }
  };

  return <OnboardingLayout>{vettingCountryHandler()}</OnboardingLayout>;
};

export default CharityVettingCountryManagerContainer;
